import React from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import {
	Button,
	Popper,
	Grow,
	ClickAwayListener,
	Paper,
	MenuList,
	MenuItem,
	IconButton,
} from '@material-ui/core';
import ProfileIcon from '@material-ui/icons/AccountCircle';

import { useMediaQuery } from 'react-responsive';
import { useCookies } from 'react-cookie';

import { Context as AuthContext } from '../context/auth.context.js';
import { Context as PortalContext } from '../context/portal.context.js';

const ToolBar = (props) => {
	const [open, setOpen] = React.useState(false);
	const portalState = React.useContext(PortalContext);
	const { state, logout } = React.useContext(AuthContext);
	const [cookies, setCookie, removeCookie] = useCookies(['sessionID']);
	const anchorRef = React.useRef(null);

	let { op } = useParams();

	let { path, url } = useRouteMatch();

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000px)' });

	let history = useHistory();

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);
	React.useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	return (
		<div
			style={{
				...styles.container,
				position: isTabletOrMobile ? 'fixed' : 'relative',
				top: 0,
				zIndex: isTabletOrMobile ? 1324345 : 123,
			}}
		>
			{/* {state.isFullAccount ? (
        <Drawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      ) : null} */}

			<div
				style={
					!isTabletOrMobile
						? { ...styles.content }
						: {
								...styles.content,
								justifyContent: 'space-between',
						  }
				}
			>
				{/* {isTabletOrMobile && state.isFullAccount ? (
          <>
            <IconButton onClick={() => setDrawerOpen(true)}>
              <MenuIcon />
            </IconButton>
          </>
        ) : null} */}

				<div
					style={{
						display: isTabletOrMobile ? 'flex' : 'none',
						width: '100%',
						justifyContent: 'center',
						marginLeft: isTabletOrMobile ? 50 : 0,
					}}
				>
					{isTabletOrMobile && (
						<img
							src={
								portalState.state.merchantLogoURL != '' && portalState.state.merchantLogoURL?.split(".com")[1].includes(".")
								? portalState.state.merchantLogoURL
								: (portalState.state.verticalMarketLogo && portalState.state.verticalMarketLogo != ''? portalState.state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
							}
							height={40}
							alt={'merchant-logo'}
						/>	
					)}
				</div>

				{isTabletOrMobile ? (
					<IconButton
						ref={anchorRef}
						aria-controls={open ? 'menu-list-grow' : undefined}
						aria-haspopup="true"
						onClick={handleToggle}
					>
						<ProfileIcon />
					</IconButton>
				) : (
					<Button
						style={{
							fontSize: 17,
							color: '#707070',
							borderRadius: 0,
						}}
						disableElevation
						variant={'text'}
						startIcon={<ProfileIcon />}
						key="3"
						ref={anchorRef}
						aria-controls={open ? 'menu-list-grow' : undefined}
						aria-haspopup="true"
						onClick={handleToggle}
					>
						{state.firstName} {state.lastName}
					</Button>
				)}

				<Popper
					open={open}
					anchorEl={anchorRef.current}
					role={undefined}
					transition
					disablePortal
					style={{ zIndex: 10000 }}
				>
					{({ TransitionProps, placement }) => (
						<Grow
							{...TransitionProps}
							style={{
								transformOrigin:
									placement === 'bottom'
										? 'center top'
										: 'center bottom',
							}}
						>
							<Paper style={{ width: 250 }} elevation={5}>
								<ClickAwayListener onClickAway={handleClose}>
									<MenuList
										autoFocusItem={open}
										id="menu-list-grow"
										onKeyDown={handleListKeyDown}
									>
										{/* <MenuItem onClick={handleClose} selected>
                      Profile
                    </MenuItem>
                    <MenuItem onClick={handleClose}>My account</MenuItem> */}
										<MenuItem
											onClick={() =>
												logout({
													sessionID:
														cookies.sessionID,
													removeCookie,
													history,
													op,
													hydratePortal:
														props.hydratePortal,
													queryString: ((portalState.state.glcode) ?  window.location.search + '?glcode=' + portalState.state.current_glcode.code : window.location.search),
												})
											}
										>
											<x-lang>Logout</x-lang>
										</MenuItem>
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
			</div>
		</div>
	);
};

const styles = {
	container: {
		height: 56,
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		background: 'white',
		borderBottom: '1px solid #e3e6e7',
	},
	content: {
		height: 56,
		maxWidth: 1300,
		width: 1300,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		fontSize: '1.5rem',
		fontFamily:
			'gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif',
	},
	text: {
		color: 'white',
	},
};
export default ToolBar;
